module.exports = __webpack_public_path__ + "img/invite.1775439203884.png";